import { render, staticRenderFns } from "./dm-graphic.vue?vue&type=template&id=4ba57d11&scoped=true&"
var script = {}
import style0 from "./dm-graphic.vue?vue&type=style&index=0&id=4ba57d11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba57d11",
  null
  
)

export default component.exports